"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgUserOkSolid(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M9.957 0a6.895 6.895 0 012.04 13.48c4.485.901 7.918 4.697 7.918 9.074v.68a.766.766 0 01-.766.766H.766A.766.766 0 010 23.234v-.68c0-4.377 3.433-8.173 7.917-9.075A6.895 6.895 0 019.957 0zM23.71 9.358c.302.239.375.659.188.982l-.064.094-4.056 5.106a.766.766 0 01-1.052.142l-.085-.073-2.072-2.042a.766.766 0 01.989-1.165l.086.074 1.464 1.443 3.526-4.438a.766.766 0 011.076-.123z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgUserOkSolid;
exports.default = _default;